import { useState, useEffect } from 'react'

function getApiBase() {
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL
  const h = window.location.hostname
  if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:3003/api/v1'
  if (h.startsWith('staging--') && h.endsWith('.ubeldi.com')) return 'https://api-staging.ubeldi.com/api/v1'
  return 'https://api.ubeldi.com/api/v1'
}

export function getAppLoginUrl(orgId) {
  if (import.meta.env.VITE_APP_URL) return `${import.meta.env.VITE_APP_URL}/login?org=${orgId}`
  const h = window.location.hostname
  if (h === 'localhost' || h === '127.0.0.1') return `http://localhost:3004/login?org=${orgId}`
  if (h.startsWith('staging--')) {
    const rootDomain = h.slice('staging--'.length)
    return `https://app-staging.${rootDomain}/login?org=${orgId}`
  }
  const rootDomain = DOMAINS.find(d => h.endsWith(d)) ? h.slice(h.indexOf('.') + 1) : h
  return `https://app.${rootDomain}/login?org=${orgId}`
}

const DOMAINS = ['.ubeldi.com', '.fitubi.com']
const RESERVED = new Set(['www', 'app', 'app-staging', 'staging', 'api', 'api-staging'])

function getSlug() {
  const h = window.location.hostname
  for (const domain of DOMAINS) {
    if (h.endsWith(domain)) {
      let sub = h.slice(0, h.length - domain.length)
      if (sub.startsWith('staging--')) sub = sub.slice('staging--'.length)
      if (!RESERVED.has(sub)) return sub
    }
  }
  // fallback for local dev: ?slug= or env var
  const params = new URLSearchParams(window.location.search)
  return params.get('slug') || import.meta.env.VITE_SLUG || null
}

export function useGymData() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [slug] = useState(() => getSlug())

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const orgId = params.get('orgId')
    const apiBase = getApiBase()

    if (orgId) {
      fetch(`${apiBase}/public/gym/preview/${orgId}`)
        .then(r => { if (!r.ok) throw new Error('Preview failed'); return r.json() })
        .then(json => setData(json?.data ?? json))
        .catch(setError)
        .finally(() => setLoading(false))
      return
    }

    if (!slug) { setLoading(false); return }

    fetch(`${apiBase}/public/gym/${slug}`)
      .then(r => { if (!r.ok) throw new Error('Gym not found'); return r.json() })
      .then(json => setData(json?.data ?? json))
      .catch(setError)
      .finally(() => setLoading(false))
  }, [slug])

  return { data, loading, error, slug }
}
